/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Edit_With_Ai_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Describe your edit…" |
*
* @param {Artifact_Edit_With_Ai_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_edit_with_ai_placeholder = /** @type {((inputs?: Artifact_Edit_With_Ai_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Edit_With_Ai_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreibe deine Änderung…")
	return /** @type {LocalizedString} */ ("Describe your edit…")
});